import { render, staticRenderFns } from "./PanelMainButtons.vue?vue&type=template&id=0c7f633d&scoped=true"
import script from "./PanelMainButtons.vue?vue&type=script&lang=ts"
export * from "./PanelMainButtons.vue?vue&type=script&lang=ts"
import style0 from "./PanelMainButtons.vue?vue&type=style&index=0&id=0c7f633d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7f633d",
  null
  
)

export default component.exports